export class ModalBlockButtonCounter {
    private static inst: ModalBlockButtonCounter;
    private _counter: number;

    constructor() {
        this._counter = 0;
    }

    static get Instance() {
        if (this.inst === null || this.inst === undefined) {
            this.inst = new ModalBlockButtonCounter();
        }
        return this.inst;
    }

    get NextValue(): number {
        return ++this._counter;
    }

    get PrevValue(): number {
        return --this._counter;
    }

    get ResetValue(): number {
        return (this._counter = 0);
    }

    get Value(): number {
        return this._counter;
    }
}
